module.exports = __webpack_public_path__ + "static/blog-img2-53a6fb4f88ff68b3a3cee71250cd5e54.png";